import {NumberRouteOption} from './number-route-option';
import {ActivatedRouteSnapshot} from '@angular/router';

/**
 * todo - review RouteOption generic type design for the RangeRouteOption use case
 *
 * Should we try to combine Start & End Year into a RangeRouteOption?
 *
 * Start year should be less than or equal to end year which would seem to indicate that
 * we should have a unified, single range option mitigate the handling required for this.
 *
 * However, it is not clear from the current RouteOption design what type values and defaultValue
 * should be since there is a constraint such that:
 *  * values: Set<Value> ;does Set<Array<number>> make any sense?
 *  * defaultValue: Value ;is this Array<number> for range option?
 *
 */
export class StartYearRouteOption extends NumberRouteOption {
	constructor(
		route: ActivatedRouteSnapshot,
		values: Set<number>,
		defaultValue: number,
	) {
		super(
			'startYear',
			route,
			values,
			defaultValue
		);
	}
}

